var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainmenuIncorrectEndorsement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.973,
    height: 23.194,
    viewBox: "0 0 20.973 23.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7480",
    "data-name": "Rectangle 7480",
    width: 20.973,
    height: 23.194,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22428",
    "data-name": "Group 22428",
    transform: "translate(-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22427",
    "data-name": "Group 22427",
    transform: "translate(9)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13231",
    "data-name": "Path 13231",
    d: "M0,8.023V7.544Q0,4.623,0,1.7A1.526,1.526,0,0,1,1.678.006C4.783,0,7.889.011,10.995,0a1.837,1.837,0,0,1,1.391.58q1.556,1.578,3.135,3.133a1.928,1.928,0,0,1,.616,1.478c-.017,2.116-.007,4.231-.007,6.347v.575c.246.061.471.113.694.172a5.539,5.539,0,0,1,.932,10.39,5.483,5.483,0,0,1-6.263-1.144,1.088,1.088,0,0,0-.869-.365c-2.954.014-5.909.009-8.864.007A1.55,1.55,0,0,1,0,19.41c0-1.746-.01-3.493.007-5.239Zm1.011,6.618c0,1.636,0,3.127,0,4.618,0,.812.09.9.884.9h8.431a9.186,9.186,0,0,1-.582-3.021c-.606,0-1.307,0-2.007,0-.36,0-.665-.093-.668-.5s.3-.515.659-.512c.772.006,1.543,0,2.311,0l.674-1.509c-1.185,0-2.327.021-3.466-.018a.914.914,0,0,1-.659-.382c-.171-.3.161-.607.622-.609,1.343-.006,2.687,0,4.03-.006a.785.785,0,0,0,.47-.1,5.849,5.849,0,0,1,3.375-1.418V5.048H13.106c-1.952,0-2.018-.065-2.018-2,0-.666,0-1.332,0-2.036H1.821c-.69,0-.806.121-.806.83,0,2.284-.011,4.568.014,6.852Zm9.876,2.99a4.532,4.532,0,1,0,4.572-4.519,4.543,4.543,0,0,0-4.572,4.519",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13232",
    "data-name": "Path 13232",
    d: "M29.7,61.071c-1.274,0-2.547,0-3.821,0-.376,0-.7-.083-.694-.525.008-.409.321-.491.678-.49q3.846.006,7.692,0c.359,0,.668.092.67.5,0,.442-.33.518-.7.516-1.274-.006-2.547,0-3.821,0",
    transform: "translate(-22.651 -54.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13233",
    "data-name": "Path 13233",
    d: "M31.088,110.079c1.19,0,2.38,0,3.569,0,.373,0,.709.074.7.516s-.351.5-.719.5c-2.363,0-7.345,0-9.708,0-.366,0-.718-.048-.727-.491-.009-.479.36-.526.744-.524,1.173.006,4.965,0,6.138,0",
    transform: "translate(-21.767 -98.986)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13234",
    "data-name": "Path 13234",
    d: "M147,144.747c0,.4.017.805,0,1.206a.739.739,0,0,1-.75.777.731.731,0,0,1-.75-.775q-.031-1.231,0-2.463a.731.731,0,0,1,.749-.776.752.752,0,0,1,.755.775c0,.033,0,.067,0,.1q0,.578,0,1.156h0",
    transform: "translate(-130.82 -128.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13235",
    "data-name": "Path 13235",
    d: "M146.378,192.735a.748.748,0,1,1-.724.745.74.74,0,0,1,.724-.745",
    transform: "translate(-130.979 -173.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13236",
    "data-name": "Path 13236",
    d: "M30.924,87.267c1.19,0,2.38,0,3.569,0,.373,0,.709.074.7.516s-.351.5-.719.5c-2.363,0-7.345,0-9.708,0-.366,0-.718-.048-.727-.491-.009-.479.36-.526.744-.524,1.173.006,4.965,0,6.138,0",
    transform: "translate(-21.619 -78.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13237",
    "data-name": "Path 13237",
    d: "M29.886,135.012c1.01,0,2.021,0,3.031,0,.317,0,.6.074.6.516s-.3.5-.611.5c-2.007,0-6.238,0-8.244,0-.311,0-.61-.048-.617-.491-.008-.479.306-.526.631-.524,1,.006,4.217,0,5.213,0",
    transform: "translate(-21.619 -121.407)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13238",
    "data-name": "Path 13238",
    d: "M28.933,160.033c.846,0,1.692,0,2.537,0,.265,0,.5.074.5.516s-.25.5-.512.5c-1.68,0-5.221,0-6.9,0-.26,0-.51-.048-.517-.491-.007-.479.256-.526.529-.524.834.006,3.53,0,4.364,0",
    transform: "translate(-21.619 -143.907)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainmenuIncorrectEndorsement);
export default __webpack_public_path__ + "static/media/Mainmenu-incorrect-endorsement.f653f49e7180b351b81dd057f81681ef.svg";
export { ForwardRef as ReactComponent };